<template>
  <div>
    <Dialog
      :key="dialogKey"
      :visible.sync="accountDialog1"
      :style="{ width: '800px', overflowY: 'auto' }"
      header="Account Form"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="Code">Customer Name</label>
          <InputText
            id="customer"
            v-model.trim="customer.custName"
            required="true"
            autofocus
            :disabled="true"
          />
        </div>
        <div class="p-field p-col">
          <label for="tasCode">TAS Code</label>
          <InputText
            id="tasCode"
            v-model.trim="account.tasCode"
            required="true"
            autofocus
            :class="{
              'p-invalid': duplicateTASCode && duplicateTASCode.length
            }"
            :disabled="disabledArr.includes('tasCode')"
            @input="checkTASForDuplicate"
          />
          <small
            class="p-invalid"
            v-if="duplicateTASCode && duplicateTASCode.length"
            >The TAS Code is already in use</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="salesExec">Branch</label>
          <div v-if="account.branchName && disabledArr.includes('mbpBranch')">
            <InputText
              id="mbpBranch"
              v-model.trim="account.branchName"
              required="true"
              autofocus
              :disabled="true"
            />
          </div>
          <div v-else>
            <Dropdown
              id="mbpBranch"
              v-model="mbpBranch"
              :options="branches"
              optionLabel="branchName"
              placeholder="Select Branch"
              :showClear="true"
              :class="{
                'p-invalid':
                  submitted && !(account.mbpBranch && account.mbpBranch.id)
              }"
              :disabled="disabledArr.includes('mbpBranch')"
            />
            <small
              class="p-invalid"
              v-if="submitted && !(account.mbpBranch && account.mbpBranch.id)"
              >Branch is required.</small
            >
          </div>
        </div>
        <div class="p-field p-col">
          <label for="salesExec">Sales Exec</label>
          <Dropdown
            id="salesExec"
            v-model="salesExec"
            :options="salesExecs"
            optionLabel="salesExecName"
            placeholder="Select Sales Executive"
            :showClear="true"
            :class="{
              'p-invalid':
                submitted &&
                account.active &&
                !(account.salesExec && account.salesExec.id)
            }"
            :disabled="disabledArr.includes('salesExecName')"
          />
          <small
            class="p-invalid"
            v-if="
              submitted &&
                account.active &&
                !(account.salesExec && account.salesExec.id)
            "
            >SalesExec is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="mainBranch">Main Branch</label>
          <br />
          <ToggleButton
            v-model="account.mainBranch"
            onLabel="Yes"
            offLabel="No"
            onIcon="pi pi-check"
            offIcon="pi pi-times"
            style="width: 100%"
            :disabled="disabledArr.includes('mainBranch')"
          />
        </div>
        <div class="p-field p-col">
          <label for="active">Active</label>
          <br />
          <ToggleButton
            v-model="account.active"
            onLabel="Yes"
            offLabel="No"
            onIcon="pi pi-check"
            offIcon="pi pi-times"
            style="width: 100%"
            :disabled="disabledArr.includes('active')"
          />
        </div>
      </div>

      <br />
      <br />
      <br />
      <br />

      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px; float:right;"
          @click="$emit('close')"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px; float:right;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px; float:right;"
          :disabled="duplicateTASCode && duplicateTASCode[0]"
          @click="save"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";
import SettingService from "@/service/SettingService";

import { customerGroup, customerMBPBranch } from "../sendRequest";

export default {
  created() {
    this.setupComponent();

    this.settingService
      .getAllActiveBranches()
      .then(data => {
        this.branches = data;
      })
      .catch(err => {
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeMbpBranches"'
        });
      });
    this.customerService
      .getAllActiveSalesExecs()
      .then(data => (this.salesExecs = data))
      .catch(e => {
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activeSalesExecs"'
        });
      });
  },
  props: {
    accountDialog: {
      type: Boolean,
      required: true
    },
    refresh: {
      type: Number,
      required: false
    },
    reload: {
      type: Number,
      required: false
    },
    disabledArr: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    accountToEdit: {
      type: Object,
      required: false
    },
    customer: {
      type: Object,
      required: true
    },
    requestType: {
      type: String,
      required: false
    }
  },
  data: () => ({
    customerService: new CustomerService(),
    settingService: new SettingService(),
    account: {
      mainBranch: false,
      active: true
    },
    dialogKey1: 0,
    submitted: false,
    branches: [],
    salesExecs: [],
    mbpBranch: {},
    salesExec: {},
    sendingRequest: false,

    duplicateTASCode: []
  }),
  computed: {
    dialogKey: {
      set() {
        this.dialogKey1++;
      },
      get() {
        return "dialog-" + this.dialogKey1;
      }
    },
    accountDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.accountDialog;
      }
    }
  },
  watch: {
    mbpBranch(val) {
      this.account.mbpBranch = val;
    },
    branches(val) {
      this.setupComponent();
    },
    salesExec(val) {
      this.account.salesExec = val;
    },
    salesExecs(val) {
      this.setupComponent();
    },
    refresh(val) {
      this.setupComponent();
    },
    reload(val) {
      this.dialogKey++;
    }
  },
  methods: {
    setupComponent() {
      this.account = {
        mainBranch: false,
        active: true
      };
      this.submitted = false;
      this.mbpBranch = {};
      this.salesExec = {};
      this.tasCode = "";
      this.duplicateTASCode = [];

      if (this.accountToEdit) {
        this.account = { ...this.accountToEdit };

        if (this.accountToEdit.mbpBranch && this.accountToEdit.mbpBranch.id) {
          this.mbpBranch = this.accountToEdit.mbpBranch;
        } else {
          if (this.accountToEdit.branchId) {
            this.mbpBranch = this.branches.find(
              a => a.branchId === this.accountToEdit.branchId
            );
          } else {
            this.mbpBranch = {};
          }
        }

        if (this.accountToEdit.salesExec && this.accountToEdit.salesExec.id) {
          this.salesExec = this.accountToEdit.salesExec;
        } else {
          if (this.accountToEdit.salesExecId) {
            this.salesExec = this.salesExecs.find(
              a => a.id === this.accountToEdit.salesExecId
            );
          } else {
            this.salesExec = {};
          }
        }
      }
    },
    save() {
      this.submitted = true;
      this.sendingRequest = true;

      if (this.requestType === "customerMBPBranch") {
        customerMBPBranch(this, "AccountForm.vue");
      } else {
        customerGroup(this, "AccountForm.vue");
      }
    },
    checkTASForDuplicate(val) {
      //
      this.duplicateTASCode = [];

      if (val && this.account && this.account.branchId) {
        this.sendingRequest = true;

        this.customerService
          .checkTASCode(val, this.account.branchId)
          .then(data => {
            this.sendingRequest = false;

            if (data.length) {
              this.duplicateTASCode = data;
            }
          })
          .catch(err => {
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while geting customer code for duplicate",
            //   life: 5000,
            // })
            this.sendingRequest = false;
            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "checkTASCode/{TASCode}/{branchId}"'
            });
          });
      }
    }
  }
};
</script>

<style></style>
